import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { FaRocket, FaShieldAlt, FaUsers, FaClock, FaChartLine, FaHeadset } from 'react-icons/fa';
import './WhyChooseUs.css';

const WhyChooseUs = () => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.2
  });

  const reasons = [
    {
      icon: <FaRocket />,
      title: "Cutting-Edge Technology",
      description: "We use the latest AI and machine learning technologies to deliver state-of-the-art solutions that keep you ahead of the competition."
    },
    {
      icon: <FaShieldAlt />,
      title: "Data Security & Privacy",
      description: "Your data security is our top priority. We implement enterprise-grade security measures and comply with all major regulations."
    },
    {
      icon: <FaUsers />,
      title: "Expert Team",
      description: "Our team consists of experienced AI engineers, data scientists, and automation specialists with proven track records."
    },
    {
      icon: <FaClock />,
      title: "Fast Implementation",
      description: "We pride ourselves on quick turnaround times without compromising quality. Most projects go live within 4-6 weeks."
    },
    {
      icon: <FaChartLine />,
      title: "Proven Results",
      description: "Our clients see an average of 65% increase in efficiency and 40% reduction in operational costs within the first year."
    },
    {
      icon: <FaHeadset />,
      title: "24/7 Support",
      description: "Round-the-clock customer support ensures your operations never stop. We're here whenever you need us."
    }
  ];

  return (
    <section id="why-choose-us" className="section why-choose-us" ref={ref}>
      <div className="container">
        <motion.div
          className="section-header"
          initial={{ opacity: 0, y: -50 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
        >
          <h2>Why Choose Avionverse</h2>
          <p>Discover what makes us the preferred AI automation partner for businesses worldwide</p>
        </motion.div>

        <div className="reasons-grid">
          {reasons.map((reason, index) => (
            <motion.div
              key={index}
              className="reason-card glass"
              initial={{ opacity: 0, y: 50 }}
              animate={inView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              whileHover={{ 
                y: -10,
                scale: 1.03,
                transition: { duration: 0.2 }
              }}
            >
              <motion.div 
                className="reason-icon"
                whileHover={{ rotate: 360, scale: 1.2 }}
                transition={{ duration: 0.6 }}
              >
                {reason.icon}
              </motion.div>
              <h3>{reason.title}</h3>
              <p>{reason.description}</p>
            </motion.div>
          ))}
        </div>

        <motion.div
          className="stats-banner glass"
          initial={{ opacity: 0, scale: 0.9 }}
          animate={inView ? { opacity: 1, scale: 1 } : {}}
          transition={{ duration: 0.6, delay: 0.8 }}
        >
          <div className="stat-item">
            <h3>500+</h3>
            <p>Projects Completed</p>
          </div>
          <div className="stat-divider"></div>
          <div className="stat-item">
            <h3>98%</h3>
            <p>Client Satisfaction</p>
          </div>
          <div className="stat-divider"></div>
          <div className="stat-item">
            <h3>50+</h3>
            <p>Countries Served</p>
          </div>
          <div className="stat-divider"></div>
          <div className="stat-item">
            <h3>24/7</h3>
            <p>Support Available</p>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
